import React from "react";

class Toast {
    static notificationAlertRef = null;

    set notificationRef(notificationAlertRef) {
        Toast.notificationAlertRef = notificationAlertRef
    }

    get notificationRef() {
        return Toast.notificationAlertRef
    }

    notify = (place, type, message, icon) => {
        const options = {
            place: place,
            message: (
                <div>
                    <p className="alert-text-custom">
                        {/*<span data-notify="icon"><FontAwesomeIcon icon={faCircleInfo} /></span>*/}
                        {message}
                    </p>
                </div>
            ),
            type: type,
            icon: icon,
        };

    };
}
    // success = (message = "") => {
    //     this.notify("tr", "success", message, "nc-icon nc-check-2");
    // };
    //
    // info = (message = "") => {
    //     this.notify("tr", "info", message);
    // };
    //
    // error = (message = "") => {
    //     this.notify("tr", "danger", message, "nc-icon nc-simple-remove");
    // };
    //
    // warning = (message = "") => {
    //     this.notify("tr", "warning", message);
    // };
    //
    // loading = (message = "") => {
    //     this.notify("tr", "info", message);
    // };
// }

// export default Toast;
export default new Toast();
